import { render, staticRenderFns } from "./RecordListItem.vue?vue&type=template&id=4ea73b80&"
import script from "./RecordListItem.vue?vue&type=script&lang=ts&"
export * from "./RecordListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports